export enum EmploymentDocumentTypeEnum {
    LetterOfEligibility = 1,
    LetterOfAcceptance = 2,
    FormRL = 3,
    VerificationOfEnrollment = 4,
    LetterOfAdmission = 5,
    FieldBasedExperienceLetter = 6,
    StatementOfEligibility = 11,
    MentorQualificationAffidavit = 58
  }